(() => {
  const STORAGE_KEY = 'bimituning:selected-vehicle';
  const dataRequests = new Map();
  const vehicleBrand = model => ['R56', 'F56'].includes(String(model || '').toUpperCase()) ? 'MINI' : 'BMW';

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-bt-open-request]');
    if (!trigger) return;
    const target = document.querySelector(trigger.getAttribute('href'));
    if (target?.matches('details')) target.open = true;
  });

  function readSelection() {
    try {
      const selection = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
      return selection && selection.model ? selection : null;
    } catch (error) {
      return null;
    }
  }

  function vehicleData(url) {
    if (!dataRequests.has(url)) {
      dataRequests.set(url, fetch(url, { credentials: 'same-origin' }).then(response => {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      }));
    }
    return dataRequests.get(url);
  }

  if (!customElements.get('bt-my-bmw')) {
    customElements.define('bt-my-bmw', class extends HTMLElement {
      connectedCallback() {
        this.modelOutput = this.querySelector('[data-bt-model]');
        this.clearButton = this.querySelector('[data-bt-clear]');
        this.clearButton?.addEventListener('click', () => this.clear());
        this.handleChange = event => this.render(event.detail || readSelection());
        window.addEventListener('bimituning:vehicle-changed', this.handleChange);
        this.render(readSelection());
      }

      disconnectedCallback() {
        window.removeEventListener('bimituning:vehicle-changed', this.handleChange);
      }

      render(selection) {
        if (!selection?.model) {
          this.hidden = true;
          return;
        }
        this.modelOutput.textContent = selection.model;
        const brandLabel = this.querySelector('[data-bt-brand-label]');
        if (brandLabel) brandLabel.textContent = `Mein ${vehicleBrand(selection.model)}:`;
        this.hidden = false;
      }

      clear() {
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
        window.dispatchEvent(new CustomEvent('bimituning:vehicle-changed', { detail: null }));
      }
    });
  }

  if (!customElements.get('bt-product-fitment')) {
    customElements.define('bt-product-fitment', class extends HTMLElement {
      connectedCallback() {
        this.box = this.querySelector('[data-bt-fitment-box]');
        this.titleOutput = this.querySelector('[data-bt-fitment-title]');
        this.textOutput = this.querySelector('[data-bt-fitment-text]');
        this.handles = new Set((this.dataset.collectionHandles || '').split(',').filter(Boolean));
        this.handleChange = event => this.update(event.detail || readSelection());
        window.addEventListener('bimituning:vehicle-changed', this.handleChange);
        this.update(readSelection());
      }

      disconnectedCallback() {
        window.removeEventListener('bimituning:vehicle-changed', this.handleChange);
      }

      setState(state, title, text) {
        this.box.classList.remove('bt-fitment--match', 'bt-fitment--check', 'bt-fitment--neutral');
        this.box.classList.add(`bt-fitment--${state}`);
        this.titleOutput.textContent = title;
        this.textOutput.textContent = text;
      }

      async update(selection) {
        if (!selection?.model) {
          this.setState('neutral', 'Noch kein BMW ausgewählt', 'Wähle dein Fahrzeug im Katalog aus, um die Passform zu prüfen.');
          return;
        }

        const model = selection.model.toUpperCase();
        this.setState('neutral', `Passform für ${model} wird geprüft …`, '');
        try {
          const data = await vehicleData(this.dataset.source);
          const allowed = new Set((data.models?.[model] || []).map(item => item.handle));
          const modelHandle = model.toLowerCase();
          const directModelMatch = !['F45', 'F46'].includes(model) && [...this.handles].some(handle =>
            handle === modelHandle || handle.startsWith(`${modelHandle}-`) || handle.endsWith(`-${modelHandle}`)
          );
          const categoryMatch = [...this.handles].some(handle => allowed.has(handle));

          if (directModelMatch || categoryMatch) {
            this.setState('match', `Passend für deinen ${vehicleBrand(model)} ${model}`, 'Die Zuordnung wurde über die Fahrzeug-Collections bestätigt. Bitte beachte zusätzlich Motorisierung und Baujahr in der Beschreibung.');
          } else {
            this.setState('check', `Passform für ${vehicleBrand(model)} ${model} bitte prüfen`, 'Für dieses Produkt ist keine eindeutige Fahrzeug-Zuordnung hinterlegt. Sende uns Modell, Motorisierung und VIN.');
          }
        } catch (error) {
          this.setState('check', `Passform für ${vehicleBrand(model)} ${model} bitte prüfen`, 'Die automatische Prüfung ist gerade nicht verfügbar.');
        }
      }
    });
  }

  if (!customElements.get('bt-mobile-nav')) {
    customElements.define('bt-mobile-nav', class extends HTMLElement {
      connectedCallback() {
        this.modelOutput = this.querySelector('[data-bt-mobile-model]');
        this.handleChange = event => this.render(event.detail || readSelection());
        window.addEventListener('bimituning:vehicle-changed', this.handleChange);
        this.render(readSelection());
      }

      disconnectedCallback() {
        window.removeEventListener('bimituning:vehicle-changed', this.handleChange);
      }

      render(selection) {
        const link = this.querySelector('[data-bt-vehicle-link]');
        if (this.modelOutput) this.modelOutput.textContent = selection?.model || link?.dataset.vehicleLabel || '';
        if (link) {
          const url = new URL(link.dataset.catalogUrl, window.location.origin);
          if (selection?.model) url.searchParams.set('vehicle', selection.model);
          link.href = url.pathname + url.search;
          link.setAttribute('aria-label', selection?.model ? `${vehicleBrand(selection.model)} ${selection.model}` : link.dataset.openLabel);
        }
      }
    });
  }

  if (!customElements.get('bt-vin-request')) {
    customElements.define('bt-vin-request', class extends HTMLElement {
      connectedCallback() {
        this.modelInput = this.querySelector('[data-bt-vin-model]');
        this.handleChange = event => this.render(event.detail || readSelection());
        window.addEventListener('bimituning:vehicle-changed', this.handleChange);
        this.render(readSelection());
      }

      disconnectedCallback() {
        window.removeEventListener('bimituning:vehicle-changed', this.handleChange);
      }

      render(selection) {
        if (!this.modelInput) return;
        const previousAutoValue = this.modelInput.dataset.btAutoValue || '';
        if (!this.modelInput.value || this.modelInput.value === previousAutoValue) {
          const nextValue = selection?.model || '';
          this.modelInput.value = nextValue;
          this.modelInput.dataset.btAutoValue = nextValue;
        }
      }
    });
  }
})();


